import { toDurationMs } from './toDurationMs';

/** Display length as `m:ss` (e.g. `3:42`). Returns undefined when unknown. */
export function formatDurationMs(durationMs?: number | null): string | undefined {
  if (durationMs == null || !Number.isFinite(durationMs) || durationMs < 0) {
    return undefined;
  }

  if (durationMs === 0) {
    return '0:00';
  }

  const totalSeconds = Math.round(durationMs / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

type DurationSource = {
  duration_ms?: number | null;
  tags?: string | { duration_ms?: number; duration?: number | string };
};

/** Resolve match duration from library row or parsed ID3/streaming metadata. */
export function resolveMatchDurationLabel(
  file: DurationSource,
): string | undefined {
  let tags: { duration_ms?: number; duration?: number | string } = {};
  if (file.tags) {
    if (typeof file.tags === 'string') {
      try {
        tags = JSON.parse(file.tags || '{}');
      } catch {
        tags = {};
      }
    } else {
      tags = file.tags;
    }
  }

  const durationMs = toDurationMs(
    file.duration_ms ?? tags.duration_ms ?? tags.duration,
  );
  return formatDurationMs(durationMs);
}
